import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { enableVisualEditing } from "@sanity/visual-editing";

export default function PreviewOverlay() {
  const location = useLocation();
  const navigate = useNavigate();
  const notifyRef = useRef(null);
  const disableRef = useRef(null);

  useEffect(() => {
    const inIframe = window.self !== window.top;
    console.log("[PreviewOverlay] mounted. inIframe:", inIframe);

    if (!inIframe) return;

    disableRef.current = enableVisualEditing({
      zIndex: 999999,
      history: {
        subscribe: (navigateFn) => {
          console.log("[PreviewOverlay] history.subscribe called - channel established!");
          notifyRef.current = navigateFn;
          navigateFn({
            type: "push",
            title: document.title,
            url: window.location.pathname + window.location.search,
          });
          return () => {
            notifyRef.current = null;
          };
        },
        update: (update) => {
          console.log("[PreviewOverlay] history.update called:", update);
          if (update.type === "push" || update.type === "replace") {
            navigate(update.url, { replace: update.type === "replace" });
          } else if (update.type === "pop") {
            navigate(-1);
          }
        },
      },
    });

    console.log("[PreviewOverlay] enableVisualEditing() called");

    return () => {
      if (disableRef.current) {
        disableRef.current();
        disableRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (notifyRef.current) {
      console.log("[PreviewOverlay] notifying location change:", location.pathname);
      notifyRef.current({
        type: "push",
        title: document.title,
        url: location.pathname + location.search,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search]);

  return null;
}
